import React from 'react';
import { ReactComponent as StarFull } from 'style/_assets/icons/star-full.svg';
import { ReactComponent as StarHalf } from 'style/_assets/icons/star-half.svg';
import { ReactComponent as StarOutline } from 'style/_assets/icons/star-outline.svg';
import { ReactComponent as StarFullYellow } from 'style/_assets/icons/star-full-yellow.svg';
import { ReactComponent as StarHalfYellow } from 'style/_assets/icons/star-half-yellow.svg';
import { ReactComponent as StarOutlineYellow } from 'style/_assets/icons/star-outline-yellow.svg';
import './Stars.scss';

import { Rate } from 'antd';

function handlePartialAndEmpty(
  partialStars,
  starArray,
  datatestid,
  disabled,
  starType,
) {
  const isYellow = starType === 'yellow';
  let StarHalfComponent = isYellow ? StarHalfYellow : StarHalf;
  let StarOutlineComponent = isYellow ? StarOutlineYellow : StarOutline;
  if (partialStars >= 0.5) {
    starArray.push(
      <Rate
        key={`${datatestid}-halfStar`}
        character={<StarHalfComponent className="star" />}
        count={1}
        disabled={disabled ? disabled : true}
      />,
    );
  }
  while (starArray.length < 5) {
    starArray.push(
      <Rate
        key={`${datatestid}-outlineStar-${starArray.length}`}
        character={<StarOutlineComponent className="star" />}
        count={1}
        disabled={disabled ? disabled : true}
      />,
    );
  }
  return starArray;
}

function getStarsFromCount(count, datatestid, disabled, starType) {
  let starArray = [];
  let partialStars = count % 1;
  let roundedCount = Math.round(count - partialStars);
  let StarComponent = starType === 'yellow' ? StarFullYellow : StarFull;
  for (let i = 0; i < roundedCount; i++) {
    starArray.push(
      <Rate
        key={`${datatestid}-wholeStar-${i}`}
        character={<StarComponent className="star" />}
        count={1}
        disabled={disabled ? disabled : true}
      />,
    );
  }
  return handlePartialAndEmpty(
    partialStars,
    starArray,
    datatestid,
    null,
    starType,
  );
}

function NoStars({ datatestid, disabled }) {
  return (
    <div data-testid={datatestid ? `${datatestid}-noStars` : null}>
      <Rate
        key={`${datatestid}-noStar`}
        character={<StarOutline className="star" />}
        count={5}
        disabled={disabled ? disabled : true}
      />
    </div>
  );
}

function Stars({ count, datatestid, disabled, starType }) {
  if (count > 5) {
    count = 5;
  }
  return (
    <div className="starsContainer">
      <div
        data-testid={datatestid ? `${datatestid}-stars` : null}
        className="starBlock"
      >
        {count && count > 0 ? (
          getStarsFromCount(count, datatestid, disabled, starType).map(item => {
            return item;
          })
        ) : (
          <NoStars disabled={disabled} datatestid={datatestid} />
        )}
      </div>
    </div>
  );
}

export default Stars;
